import { Table } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../../../../components";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { envChangeType, getCurrency } from "../../../../../../../plugins/utils";
import { useComission } from "../../../../context/ComissionContext";
import { useGetPlatformFee } from "../../../../hooks/comissionreport.hooks";
import styles from "./style.module.scss";
const CURRENCY = getCurrency();

const Platform = () => {
  const { t } = useTranslation();
  const { selectedMonth, agentBonusId, selectedWeek } = useComission();
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading, isError } =
    useGetPlatformFee({
      params: {
        // period_month: selectedMonth.value,
        period_date: selectedWeek?.value?.split("~")[0],
      },
      agent_bonus_id: agentBonusId,
      options: {
        enabled: selectedWeek !== null && agentBonusId !== null,
        getNextPageParam: (lastPage, pages) => {
          if (pages.length < lastPage.last_page) {
            return pages.length + 1;
          } else {
            return undefined;
          }
        },
      },
    });
  const [summary, setSummary] = useState(0);
  const [localData, setLocalData] = useState([]);

  const columns = [
    {
      title: t("comission.table.platformName"),
      width: 100,
      align: "center",
      dataIndex: "game_category_code",
      render: (text, record, index) => (
        <>{`${t([
          `comission.platform.game.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${record.game_3th_code}`,
          `comission.platform.game.${record.game_3th_code}`,
        ])}`}</>
      ),
    },
    {
      title: `${t("comission.table.platformWinLoss")} (${t(`global.currency.${CURRENCY}`)})`,
      width: 100,
      align: "center",
      dataIndex: "total_win_loss_amount",
      render: (text, record, index) => (
        <div className={`${styles.amount} ${text <= 0 ? styles.redColor : styles.greenColor}`}>
          {moneyFormat(text)}
        </div>
      ),
    },
    {
      title: t("comission.table.platformRate"),
      width: 100,
      align: "center",
      dataIndex: "game_3th_fee_rate",
      render: (text, record, index) => <>{`${text} %`}</>,
    },
    {
      title: `${t("comission.table.platformFee")} (${t(`global.currency.${CURRENCY}`)})`,
      width: 100,
      align: "center",
      dataIndex: "game_3th_fee_amount",
      render: (text, record, index) => (
        <div className={`${styles.amount} ${text <= 0 ? styles.redColor : styles.greenColor}`}>
          {moneyFormat(text)}
        </div>
      ),
    },
  ];

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (data) {
      const page_length = data.pages.length;
      if (page_length <= 1) {
        setLocalData([...data.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...data.pages[page_length - 1].data];
        });
      }
      const totalFee = data.pages[page_length - 1].data.reduce(
        (sum, a) => sum + (a.game_3th_fee_amount || 0),
        0,
      );
      setSummary(totalFee);
    }
  }, [data]);

  const onHandleSearch = () => {};

  return (
    <div className={styles.container}>
      {isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
          summary={() => {
            return (
              <Table.Summary fixed="top">
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <div className={styles.summaryCell}>{t("normal.summary")}</div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} />
                  <Table.Summary.Cell index={2} />
                  <Table.Summary.Cell index={3}>
                    <div
                      className={`${styles.summaryCell} ${styles.content} ${
                        summary <= 0 ? styles.redColor : styles.greenColor
                      }`}
                    >
                      {moneyFormat(summary || 0)}
                    </div>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      )}
    </div>
  );
};

export default Platform;
